import { PendingReportCreate } from '../../../../application/ReportsQueueService';
import { PendingReportsActions, PendingReportsActionType } from './actions';

export interface PendingReportsState {
  pendingReports: PendingReportCreate[];
}

export const getInitialState = (): PendingReportsState => ({
  pendingReports: [],
});

export const PendingReportsReducer = (
  state: PendingReportsState,
  action: PendingReportsActions
): PendingReportsState => {
  switch (action.type) {
    case PendingReportsActionType.SET_PENDING_REPORTS:
      return {
        ...state,
        pendingReports: action.payload,
      };
    default:
      return state;
  }
};
